__turbopack_context__.v({
  "agenticBlueCta": "workspaceAgentStartTaskCta-module__CzbAbq__agenticBlueCta",
  "agenticBlueCtaRingSheen": "workspaceAgentStartTaskCta-module__CzbAbq__agenticBlueCtaRingSheen",
});
